import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class CreateOperativeUnitHasOnCallTypeDto {
  @Expose()
  operativeUnitId: string;

  @Expose()
  onCallTypeId: string;

  @Expose()
  @Transform(({ value }) => toCents(value))
  cost: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  price: number;
}
